<template>
  <layout title="Manage Referrals">
    <add-button :to="{ name: 'referral', params: { id: 'new' } }" slot="add">
      Add Referral
    </add-button>
    <dynamic-table-view
      :show-search="true"
      :headers="headers"
      :list="referrals"
      search-placeholder="Search by Name or Email"
    >
      <template v-slot:item.full_name="{ value, item }">
        <router-link
          class="text-decoration-none"
          :to="{ name: 'referral-transaction', params: { id: item.id } }"
        >
          {{ value }}
        </router-link>
      </template>
      <template v-slot:item.transaction_amount="{ value }">
        {{ formatPrice(value || 0) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="d-flex align-center">
          <delete-icon-button
              v-if="hasDelete('referrals')"
              @click="removeReferral(item)"
          />
          <edit-icon-button
              v-if="hasEdit('referrals')"
              :to="{ name: 'referral', params: { id: item.id } }"
          ></edit-icon-button>
        </div>
      </template>
    </dynamic-table-view>
  </layout>
</template>

<script>
import Layout from "@/components/ui/Layout.vue";
import store from "@/store";
import DynamicTableView from "@/components/ui/DynamicTableView.vue";
import AddButton from "@/components/ui/buttons/AddButton.vue";
import EditIconButton from "@/components/ui/buttons/EditIconButton.vue";
import DeleteIconButton from "@/components/ui/buttons/DeleteIconButton.vue";
import { colReferrals, colClients } from "@/assets/utils/firebase.utils";
import { getDocs, getCountFromServer, orderBy, query, where } from "firebase/firestore";

export default {
  components: { DeleteIconButton, EditIconButton, AddButton, DynamicTableView, Layout },
  data() {
    return {
      referrals: [],
      headers: [
        { text: "Referral Name", value: "full_name", sortable: false },
        { text: "Email", value: "email", sortable: false },
        { text: "Clients Referred", value: "clients_referred", sortable: false, align: "center" },
        {
          text: "Total Transaction Amount",
          value: "transaction_amount",
          sortable: false,
        },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  async mounted() {
    await this.fetchReferrals();
  },
  methods: {
    async fetchReferrals() {
      try {
        const q = query(colReferrals, orderBy("transaction_amount", "desc"));
        const snapshot = await getDocs(q);
        this.referrals = await Promise.all(
          snapshot.docs.map(async (doc) => {
            const data = doc.data();
            const clientsQuery = query(colClients, where("referral_id", "==", doc.id));
            const clientsCount = await getCountFromServer(clientsQuery);
            return {
              id: doc.id,
              full_name: `${data.first_name} ${data.last_name}`,
              email: data.email,
              clients_referred: clientsCount.data().count,
              transaction_amount: data.transaction_amount || 0,
            };
          })
        );
      } catch (error) {
        this.handleError(error.message);
      }
    },
    removeReferral(item) {
      this.$confirm.show({
        title: "Delete Referral",
        message: `Are you sure you want to delete referral "${item.full_name}"? This action cannot be undone.`,
        onConfirm: async () => {
          try {
            await store.dispatch("deleteReferral", item.id);
            this.referrals = this.referrals.filter((r) => r.id !== item.id);
            this.notifySuccess("Referral deleted successfully");
          } catch (error) {
            this.handleError(error.message);
          }
        }
      });
    },
  },
};
</script>
